<div *ngIf="loading" class="berth-qr-panel__loading">
    <mat-spinner diameter="32"></mat-spinner>
</div>

<ng-container *ngIf="!loading">
  <p *ngIf="!qrInfo?.qrCodeFileId" class="berth-qr-panel__empty">
    {{ 'bcmBerths.onlineBookingQr.notGeneratedYet' | translate }}
  </p>

  <div *ngIf="qrInfo?.qrCodeFileId" class="berth-qr-panel__content">
    <div *ngIf="qrImageUrl" class="berth-qr-panel__preview">
      <img [src]="qrImageUrl" [alt]="'bcmBerths.onlineBookingQr.imageAlt' | translate">
    </div>

    <p *ngIf="qrInfo?.publicUrl" class="berth-qr-panel__url">
      <span class="berth-qr-panel__url-label">{{ 'bcmBerths.onlineBookingQr.publicUrl' | translate }}</span>
      <a [href]="qrInfo.publicUrl" target="_blank" rel="noopener">{{ qrInfo.publicUrl }}</a>
    </p>
  </div>

  <div class="berth-qr-panel__sticker-options">
    <p class="berth-qr-panel__sticker-options-title">
      {{ 'bcmBerths.onlineBookingQr.stickerOptionsTitle' | translate }}
    </p>

    <mat-slide-toggle
      class="berth-qr-panel__sticker-toggle"
      [checked]="qrStickerIncludeLogo"
      [disabled]="savingStickerOptions"
      (change)="onQrStickerIncludeLogoChange($event.checked)">
      <span class="berth-qr-panel__sticker-toggle-label">
        {{ 'settings.addOns.onlineBooking.qrStickerIncludeLogo' | translate }}
      </span>
      <span class="berth-qr-panel__sticker-toggle-hint">
        {{ 'settings.addOns.onlineBooking.qrStickerIncludeLogoHint' | translate }}
      </span>
    </mat-slide-toggle>

    <mat-slide-toggle
      class="berth-qr-panel__sticker-toggle"
      [checked]="qrStickerIncludeCaption"
      [disabled]="savingStickerOptions"
      (change)="onQrStickerIncludeCaptionChange($event.checked)">
      <span class="berth-qr-panel__sticker-toggle-label">
        {{ 'settings.addOns.onlineBooking.qrStickerIncludeCaption' | translate }}
      </span>
      <span class="berth-qr-panel__sticker-toggle-hint">
        {{ 'settings.addOns.onlineBooking.qrStickerIncludeCaptionHint' | translate }}
      </span>
    </mat-slide-toggle>

    <p class="berth-qr-panel__settings-hint">
      {{ 'bcmBerths.onlineBookingQr.stickerBrandingHint' | translate }}
    </p>
  </div>

  <div class="berth-qr-panel__actions">
    <button mat-stroked-button type="button"
            *ngIf="qrInfo?.publicUrl"
            (click)="copyUrl()">
      <mat-icon>content_copy</mat-icon>
      {{ 'bcmBerths.onlineBookingQr.copyUrl' | translate }}
    </button>

    <button mat-stroked-button type="button"
            *ngIf="qrInfo?.qrCodeFileId"
            (click)="downloadQr()">
      <mat-icon>download</mat-icon>
      {{ 'bcmBerths.onlineBookingQr.download' | translate }}
    </button>

    <button mat-flat-button color="primary" type="button"
            [disabled]="generating || !berthId"
            (click)="generateQr()">
      <mat-icon>{{ qrInfo?.qrCodeFileId ? 'refresh' : 'qr_code_2' }}</mat-icon>
      {{ qrInfo?.qrCodeFileId
          ? ('bcmBerths.onlineBookingQr.regenerate' | translate)
          : ('bcmBerths.onlineBookingQr.generate' | translate) }}
    </button>
  </div>
</ng-container>
